'use client';

import { useMemo } from 'react';

import { useAppStore } from '@/shared/contexts/app-wrapper/providers/app-provider';
import {
	SENDER_FIRST_NAME_VARIABLE,
	SENDER_NAME_VARIABLE,
	TEMPLATE_VARIABLES,
} from '@/shared/constants/message-constants';

import { getFullName } from '@/models/user/user';

/** token → value for one-to-one messages, which the app resolves (bulk sends resolve on the server).
 *  `jobName` is passed in rather than read from the job context: the Messages page chat box sits
 *  outside that context. */
export function useMessageVariableValues({
	firstName,
	jobName,
}: {
	firstName: string;
	jobName?: string;
}): Record<string, string> {
	const userDetails = useAppStore((state) => state.userDetails);

	return useMemo(
		() => ({
			// Without a name, a typed {first_name} stays as written until a template insert blanks it.
			...(firstName ? { '{first_name}': firstName } : {}),
			[TEMPLATE_VARIABLES.jobName.token]: jobName ?? '',
			[SENDER_FIRST_NAME_VARIABLE.token]: userDetails?.firstName?.trim() ?? '',
			[SENDER_NAME_VARIABLE.token]: getFullName(userDetails).trim(),
		}),
		[firstName, jobName, userDetails]
	);
}
